var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { layoutSxFromProps, } from '@revdotcom/vaporwave-system';
import { useOverlay, usePreventScroll, useModal, OverlayContainer, } from '@react-aria/overlays';
import { getDialogUnderlaySx } from '@revdotcom/vaporwave-sx';
import { useDialog } from '@react-aria/dialog';
import { FocusScope } from '@react-aria/focus';
import { DialogContent } from './DialogContent';
/**
 * Renders a vaporwave Dialog with the specified `title` prop in its header and `children` prop as its body.
 *
 * The vaporwave Dialog can be styled using the styled-system width and height props.
 */
export var Dialog = function (_a) {
    var title = _a.title, children = _a.children, rest = __rest(_a, ["title", "children"]);
    if (rest.isDismissable === true && rest.onClose === undefined) {
        console.warn('WARNING: isDismissable was set to true but no onClose callback was provided. ' +
            'Nothing will happen when the user clicks outside of your Dialog. ' +
            'Please set isDismissable to false or implement an onClose function.');
    }
    // Manage the render state for dialog open and close animations.
    var _b = useState(rest.isOpen), shouldRender = _b[0], setRender = _b[1];
    useEffect(function () {
        rest.isOpen && setRender(true);
    }, [rest.isOpen]);
    var onAnimationEnd = function () {
        !rest.isOpen && setRender(false);
    };
    // Handle interacting outside the dialog and pressing
    // the Escape key to close the dialog.
    var ref = React.useRef(null);
    var _c = useOverlay(rest, ref), overlayProps = _c.overlayProps, underlayProps = _c.underlayProps;
    // Prevent scrolling while the dialog is open, and hide content
    // outside the dialog from screen readers.
    usePreventScroll({ isDisabled: !rest.isOpen });
    useModal({ isDisabled: !rest.isOpen });
    // Get props for the dialog and its title.
    var _d = useDialog(rest, ref), dialogProps = _d.dialogProps, titleProps = _d.titleProps;
    return shouldRender ? (_jsx(OverlayContainer, { children: _jsx("div", __assign({}, underlayProps, { sx: getDialogUnderlaySx(), children: _jsx(FocusScope, { contain: true, restoreFocus: true, autoFocus: true, children: _jsx(DialogContent, __assign({ title: title, onAnimationEnd: onAnimationEnd, dialogRef: ref, isStatic: false, overlayProps: overlayProps, dialogProps: dialogProps, titleProps: titleProps, overflowY: 'auto', 
                    // Include styles declared in width and height props
                    sx: layoutSxFromProps(rest) }, rest, { children: children })) }) })) })) : null;
};
